export const countries = [
    { code: "AF", name: "Afghanistan", phone: 93, regex: "^\\+93\\d{9}$" },
    { code: "AX", name: "Aland Islands", phone: 358, regex: "^\\+358\\d{6,11}$" },
    { code: "AL", name: "Albania", phone: 355, regex: "^\\+355\\d{8,9}$" },
    { code: "DZ", name: "Algeria", phone: 213, regex: "^\\+213\\d{8,9}$" },
    { code: "AS", name: "American Samoa", phone: 1684, regex: "^\\+1684\\d{7}$" },
    { code: "AD", name: "Andorra", phone: 376, regex: "^\\+376\\d{6}$" },
    { code: "AO", name: "Angola", phone: 244, regex: "^\\+244\\d{9}$" },
    { code: "AI", name: "Anguilla", phone: 1264, regex: "^\\+1264\\d{7}$" },
    { code: "AQ", name: "Antarctica", phone: 672, regex: "^\\+672\\d{5,7}$" },
    { code: "AG", name: "Antigua and Barbuda", phone: 1268, regex: "^\\+1268\\d{7}$" },
    { code: "AR", name: "Argentina", phone: 54, regex: "^\\+54\\d{10}$" },
    { code: "AM", name: "Armenia", phone: 374, regex: "^\\+374\\d{8}$" },
    { code: "AW", name: "Aruba", phone: 297, regex: "^\\+297\\d{7}$" },
    { code: "AU", name: "Australia", phone: 61, regex: "^\\+61\\d{9}$" },
    { code: "AT", name: "Austria", phone: 43, regex: "^\\+43\\d{10}$" },
    { code: "AZ", name: "Azerbaijan", phone: 994, regex: "^\\+994\\d{9}$" },
    { code: "BS", name: "Bahamas", phone: 1242, regex: "^\\+1242\\d{7}$" },
    { code: "BH", name: "Bahrain", phone: 973, regex: "^\\+973\\d{8}$" },
    { code: "BD", name: "Bangladesh", phone: 880, regex: "^\\+880\\d{10}$" },
    { code: "BB", name: "Barbados", phone: 1246, regex: "^\\+1246\\d{7}$" },
    { code: "BY", name: "Belarus", phone: 375, regex: "^\\+375\\d{9}$" },
    { code: "BE", name: "Belgium", phone: 32, regex: "^\\+32\\d{8,9}$" },
    { code: "BZ", name: "Belize", phone: 501, regex: "^\\+501\\d{7}$" },
    { code: "BJ", name: "Benin", phone: 229, regex: "^\\+229\\d{8}$" },
    { code: "BM", name: "Bermuda", phone: 1441, regex: "^\\+1441\\d{7}$" },
    { code: "BT", name: "Bhutan", phone: 975, regex: "^\\+975\\d{7,8}$" },
    { code: "BO", name: "Bolivia", phone: 591, regex: "^\\+591\\d{8}$" },
    { code: "BQ", name: "Bonaire, Sint Eustatius and Saba", phone: 599, regex: "^\\+599\\d{7}$" },
    { code: "BA", name: "Bosnia and Herzegovina", phone: 387, regex: "^\\+387\\d{8}$" },
    { code: "BW", name: "Botswana", phone: 267, regex: "^\\+267\\d{7,8}$" },
    { code: "BV", name: "Bouvet Island", phone: 55, regex: "^\\+55\\d{10}$" },
    { code: "BR", name: "Brazil", phone: 55, regex: "^\\+55\\d{10}$" },
    { code: "IO", name: "British Indian Ocean Territory", phone: 246, regex: "^\\+246\\d{7}$" },
    { code: "BN", name: "Brunei Darussalam", phone: 673, regex: "^\\+673\\d{7}$" },
    { code: "BG", name: "Bulgaria", phone: 359, regex: "^\\+359\\d{8,9}$" },
    { code: "BF", name: "Burkina Faso", phone: 226, regex: "^\\+226\\d{8}$" },
    { code: "BI", name: "Burundi", phone: 257, regex: "^\\+257\\d{8}$" },
    { code: "KH", name: "Cambodia", phone: 855, regex: "^\\+855\\d{8,9}$" },
    { code: "CM", name: "Cameroon", phone: 237, regex: "^\\+237\\d{8,9}$" },
    { code: "CA", name: "Canada", phone: 1, regex: "^\\+1\\d{10}$" },
    { code: "CV", name: "Cape Verde", phone: 238, regex: "^\\+238\\d{7}$" },
    { code: "KY", name: "Cayman Islands", phone: 1345, regex: "^\\+1345\\d{7}$" },
    { code: "CF", name: "Central African Republic", phone: 236, regex: "^\\+236\\d{7,8}$" },
    { code: "TD", name: "Chad", phone: 235, regex: "^\\+235\\d{8}$" },
    { code: "CL", name: "Chile", phone: 56, regex: "^\\+56\\d{9}$" },
    { code: "CN", name: "China", phone: 86, regex: "^\\+86\\d{11}$" },
    { code: "CX", name: "Christmas Island", phone: 61, regex: "^\\+61\\d{9}$" },
    { code: "CC", name: "Cocos (Keeling) Islands", phone: 672, regex: "^\\+672\\d{6}$" },
    { code: "CO", name: "Colombia", phone: 57, regex: "^\\+57\\d{10}$" },
    { code: "KM", name: "Comoros", phone: 269, regex: "^\\+269\\d{7}$" },
    { code: "CG", name: "Congo", phone: 242, regex: "^\\+242\\d{9}$" },
    { code: "CD", name: "Congo, Democratic Republic of the Congo", phone: 243, regex: "^\\+243\\d{9,10}$" },
    { code: "CK", name: "Cook Islands", phone: 682, regex: "^\\+682\\d{5}$" },
    { code: "CR", name: "Costa Rica", phone: 506, regex: "^\\+506\\d{8}$" },
    { code: "CI", name: "Cote D'Ivoire", phone: 225, regex: "^\\+225\\d{8}$" },
    { code: "HR", name: "Croatia", phone: 385, regex: "^\\+385\\d{8,9}$" },
    { code: "CU", name: "Cuba", phone: 53, regex: "^\\+53\\d{8}$" },
    { code: "CW", name: "Curacao", phone: 599, regex: "^\\+599\\d{7}$" },
    { code: "CY", name: "Cyprus", phone: 357, regex: "^\\+357\\d{8}$" },
    { code: "CZ", name: "Czech Republic", phone: 420, regex: "^\\+420\\d{9}$" },
    { code: "DK", name: "Denmark", phone: 45, regex: "^\\+45\\d{8}$" },
    { code: "DJ", name: "Djibouti", phone: 253, regex: "^\\+253\\d{6,7}$" },
    { code: "DM", name: "Dominica", phone: 1767, regex: "^\\+1767\\d{7}$" },
    { code: "DO", name: "Dominican Republic", phone: 1809, regex: "^\\+1809\\d{7}$" },
    { code: "EC", name: "Ecuador", phone: 593, regex: "^\\+593\\d{8,9}$" },
    { code: "EG", name: "Egypt", phone: 20, regex: "^\\+20\\d{9,10}$" },
    { code: "SV", name: "El Salvador", phone: 503, regex: "^\\+503\\d{8}$" },
    { code: "GQ", name: "Equatorial Guinea", phone: 240, regex: "^\\+240\\d{9}$" },
    { code: "ER", name: "Eritrea", phone: 291, regex: "^\\+291\\d{6,7}$" },
    { code: "EE", name: "Estonia", phone: 372, regex: "^\\+372\\d{7,8}$" },
    { code: "ET", name: "Ethiopia", phone: 251, regex: "^\\+251\\d{8,9}$" },
    { code: "FK", name: "Falkland Islands (Malvinas)", phone: 500, regex: "^\\+500\\d{5}$" },
    { code: "FO", name: "Faroe Islands", phone: 298, regex: "^\\+298\\d{6}$" },
    { code: "FJ", name: "Fiji", phone: 679, regex: "^\\+679\\d{7}$" },
    { code: "FI", name: "Finland", phone: 358, regex: "^\\+358\\d{8,10}$" },
    { code: "FR", name: "France", phone: 33, regex: "^\\+33\\d{9}$" },
    { code: "GF", name: "French Guiana", phone: 594, regex: "^\\+594\\d{9}$" },
    { code: "PF", name: "French Polynesia", phone: 689, regex: "^\\+689\\d{8}$" },
    { code: "TF", name: "French Southern Territories", phone: 262, regex: "^\\+262\\d{9}$" },
    { code: "GA", name: "Gabon", phone: 241, regex: "^\\+241\\d{7,8}$" },
    { code: "GM", name: "Gambia", phone: 220, regex: "^\\+220\\d{7}$" },
    { code: "GE", name: "Georgia", phone: 995, regex: "^\\+995\\d{8,9}$" },
    { code: "DE", name: "Germany", phone: 49, regex: "^\\+49\\d{10}$" },
    { code: "GH", name: "Ghana", phone: 233, regex: "^\\+233\\d{9}$" },
    { code: "GI", name: "Gibraltar", phone: 350, regex: "^\\+350\\d{8}$" },
    { code: "GR", name: "Greece", phone: 30, regex: "^\\+30\\d{10}$" },
    { code: "GL", name: "Greenland", phone: 299, regex: "^\\+299\\d{6}$" },
    { code: "GD", name: "Grenada", phone: 1473, regex: "^\\+1473\\d{7}$" },
    { code: "GP", name: "Guadeloupe", phone: 590, regex: "^\\+590\\d{9}$" },
    { code: "GU", name: "Guam", phone: 1671, regex: "^\\+1671\\d{7}$" },
    { code: "GT", name: "Guatemala", phone: 502, regex: "^\\+502\\d{8}$" },
    { code: "GG", name: "Guernsey", phone: 44, regex: "^\\+44\\d{10}$" },
    { code: "GN", name: "Guinea", phone: 224, regex: "^\\+224\\d{9}$" },
    { code: "GW", name: "Guinea-Bissau", phone: 245, regex: "^\\+245\\d{7}$" },
    { code: "GY", name: "Guyana", phone: 592, regex: "^\\+592\\d{7}$" },
    { code: "HT", name: "Haiti", phone: 509, regex: "^\\+509\\d{8}$" },
    { code: "HM", name: "Heard Island and Mcdonald Islands", phone: 672, regex: "^\\+672\\d{5,7}$" },
    { code: "VA", name: "Holy See (Vatican City State)", phone: 379, regex: "^\\+379\\d{6,10}$" },
    { code: "HN", name: "Honduras", phone: 504, regex: "^\\+504\\d{8}$" },
    { code: "HK", name: "Hong Kong", phone: 852, regex: "^\\+852\\d{8}$" },
    { code: "HU", name: "Hungary", phone: 36, regex: "^\\+36\\d{9}$" },
    { code: "IS", name: "Iceland", phone: 354, regex: "^\\+354\\d{7}$" },
    { code: "IN", name: "India", phone: 91, regex: "^\\+91\\d{10}$" },
    { code: "ID", name: "Indonesia", phone: 62, regex: "^\\+62\\d{9,10}$" },
    { code: "IR", name: "Iran, Islamic Republic of", phone: 98, regex: "^\\+98\\d{9,10}$" },
    { code: "IQ", name: "Iraq", phone: 964, regex: "^\\+964\\d{9,10}$" },
    { code: "IE", name: "Ireland", phone: 353, regex: "^\\+353\\d{9,10}$" },
    { code: "IM", name: "Isle of Man", phone: 44, regex: "^\\+44\\d{10}$" },
    { code: "IL", name: "Israel", phone: 972, regex: "^\\+972\\d{8,9}$" },
    { code: "IT", name: "Italy", phone: 39, regex: "^\\+39\\d{9,10}$" },
    { code: "JM", name: "Jamaica", phone: 1876, regex: "^\\+1876\\d{7}$" },
    { code: "JP", name: "Japan", phone: 81, regex: "^\\+81\\d{9,10}$" },
    { code: "JE", name: "Jersey", phone: 44, regex: "^\\+44\\d{10}$" },
    { code: "JO", name: "Jordan", phone: 962, regex: "^\\+962\\d{8,9}$" },
    { code: "KZ", name: "Kazakhstan", phone: 7, regex: "^\\+7\\d{10}$" },
    { code: "KE", name: "Kenya", phone: 254, regex: "^\\+254\\d{9}$" },
    { code: "KI", name: "Kiribati", phone: 686, regex: "^\\+686\\d{5}$" },
    { code: "KP", name: "Korea, Democratic People's Republic of", phone: 850, regex: "^\\+850\\d{6,8}$" },
    { code: "KR", name: "Korea, Republic of", phone: 82, regex: "^\\+82\\d{8,10}$" },
    { code: "XK", name: "Kosovo", phone: 383, regex: "^\\+383\\d{8,9}$" },
    { code: "KW", name: "Kuwait", phone: 965, regex: "^\\+965\\d{8}$" },
    { code: "KG", name: "Kyrgyzstan", phone: 996, regex: "^\\+996\\d{8,9}$" },
    { code: "LA", name: "Lao People's Democratic Republic", phone: 856, regex: "^\\+856\\d{9,10}$" },
    { code: "LV", name: "Latvia", phone: 371, regex: "^\\+371\\d{8}$" },
    { code: "LB", name: "Lebanon", phone: 961, regex: "^\\+961\\d{7,8}$" },
    { code: "LS", name: "Lesotho", phone: 266, regex: "^\\+266\\d{8}$" },
    { code: "LR", name: "Liberia", phone: 231, regex: "^\\+231\\d{7,8}$" },
    { code: "LY", name: "Libya", phone: 218, regex: "^\\+218\\d{8,9}$" },
    { code: "LI", name: "Liechtenstein", phone: 423, regex: "^\\+423\\d{7}$" },
    { code: "LT", name: "Lithuania", phone: 370, regex: "^\\+370\\d{8}$" },
    { code: "LU", name: "Luxembourg", phone: 352, regex: "^\\+352\\d{8,9}$" },
    { code: "MO", name: "Macao", phone: 853, regex: "^\\+853\\d{8}$" },
    { code: "MK", name: "Macedonia, The Former Yugoslav Republic of", phone: 389, regex: "^\\+389\\d{8}$" },
    { code: "MG", name: "Madagascar", phone: 261, regex: "^\\+261\\d{9}$" },
    { code: "MW", name: "Malawi", phone: 265, regex: "^\\+265\\d{9}$" },
    { code: "MY", name: "Malaysia", phone: 60, regex: "^\\+60\\d{8,9}$" },
    { code: "MV", name: "Maldives", phone: 960, regex: "^\\+960\\d{7}$" },
    { code: "ML", name: "Mali", phone: 223, regex: "^\\+223\\d{8}$" },
    { code: "MT", name: "Malta", phone: 356, regex: "^\\+356\\d{8}$" },
    { code: "MH", name: "Marshall Islands", phone: 692, regex: "^\\+692\\d{7}$" },
    { code: "MQ", name: "Martinique", phone: 596, regex: "^\\+596\\d{9}$" },
    { code: "MR", name: "Mauritania", phone: 222, regex: "^\\+222\\d{8}$" },
    { code: "MU", name: "Mauritius", phone: 230, regex: "^\\+230\\d{7}$" },
    { code: "YT", name: "Mayotte", phone: 262, regex: "^\\+262\\d{9}$" },
    { code: "MX", name: "Mexico", phone: 52, regex: "^\\+52\\d{10}$" },
    { code: "FM", name: "Micronesia, Federated States of", phone: 691, regex: "^\\+691\\d{7}$" },
    { code: "MD", name: "Moldova, Republic of", phone: 373, regex: "^\\+373\\d{8}$" },
    { code: "MC", name: "Monaco", phone: 377, regex: "^\\+377\\d{8}$" },
    { code: "MN", name: "Mongolia", phone: 976, regex: "^\\+976\\d{8}$" },
    { code: "ME", name: "Montenegro", phone: 382, regex: "^\\+382\\d{8}$" },
    { code: "MS", name: "Montserrat", phone: 1664, regex: "^\\+1664\\d{7}$" },
    { code: "MA", name: "Morocco", phone: 212, regex: "^\\+212\\d{9}$" },
    { code: "MZ", name: "Mozambique", phone: 258, regex: "^\\+258\\d{8,9}$" },
    { code: "MM", name: "Myanmar", phone: 95, regex: "^\\+95\\d{8,9}$" },
    { code: "NA", name: "Namibia", phone: 264, regex: "^\\+264\\d{9}$" },
    { code: "NR", name: "Nauru", phone: 674, regex: "^\\+674\\d{7}$" },
    { code: "NP", name: "Nepal", phone: 977, regex: "^\\+977\\d{8}$" },
    { code: "NL", name: "Netherlands", phone: 31, regex: "^\\+31\\d{9}$" },
    { code: "NC", name: "New Caledonia", phone: 687, regex: "^\\+687\\d{6}$" },
    { code: "NZ", name: "New Zealand", phone: 64, regex: "^\\+64\\d{8,9}$" },
    { code: "NI", name: "Nicaragua", phone: 505, regex: "^\\+505\\d{8}$" },
    { code: "NE", name: "Niger", phone: 227, regex: "^\\+227\\d{8}$" },
    { code: "NG", name: "Nigeria", phone: 234, regex: "^\\+234\\d{8,10}$" },
    { code: "NU", name: "Niue", phone: 683, regex: "^\\+683\\d{4}$" },
    { code: "NF", name: "Norfolk Island", phone: 672, regex: "^\\+672\\d{5,7}$" },
    { code: "MP", name: "Northern Mariana Islands", phone: 1670, regex: "^\\+1670\\d{7}$" },
    { code: "NO", name: "Norway", phone: 47, regex: "^\\+47\\d{8}$" },
    { code: "OM", name: "Oman", phone: 968, regex: "^\\+968\\d{8}$" },
    { code: "PK", name: "Pakistan", phone: 92, regex: "^\\+92\\d{10}$" },
    { code: "PW", name: "Palau", phone: 680, regex: "^\\+680\\d{7}$" },
    { code: "PS", name: "Palestine, State of", phone: 970, regex: "^\\+970\\d{8,9}$" },
    { code: "PA", name: "Panama", phone: 507, regex: "^\\+507\\d{8}$" },
    { code: "PG", name: "Papua New Guinea", phone: 675, regex: "^\\+675\\d{8}$" },
    { code: "PY", name: "Paraguay", phone: 595, regex: "^\\+595\\d{9}$" },
    { code: "PE", name: "Peru", phone: 51, regex: "^\\+51\\d{8,9}$" },
    { code: "PH", name: "Philippines", phone: 63, regex: "^\\+63\\d{9,10}$" },
    { code: "PN", name: "Pitcairn", phone: 64, regex: "^\\+64\\d{8,9}$" },
    { code: "PL", name: "Poland", phone: 48, regex: "^\\+48\\d{9}$" },
    { code: "PT", name: "Portugal", phone: 351, regex: "^\\+351\\d{9}$" },
    { code: "PR", name: "Puerto Rico", phone: 1, regex: "^\\+1\\d{10}$" },
    { code: "QA", name: "Qatar", phone: 974, regex: "^\\+974\\d{8}$" },
    { code: "RE", name: "Reunion", phone: 262, regex: "^\\+262\\d{9}$" },
    { code: "RO", name: "Romania", phone: 40, regex: "^\\+40\\d{9}$" },
    { code: "RU", name: "Russian Federation", phone: 7, regex: "^\\+7\\d{10}$" },
    { code: "RW", name: "Rwanda", phone: 250, regex: "^\\+250\\d{9}$" },
    { code: "BL", name: "Saint Barthelemy", phone: 590, regex: "^\\+590\\d{9}$" },
    { code: "SH", name: "Saint Helena", phone: 290, regex: "^\\+290\\d{4}$" },
    { code: "KN", name: "Saint Kitts and Nevis", phone: 1869, regex: "^\\+1869\\d{7}$" },
    { code: "LC", name: "Saint Lucia", phone: 1758, regex: "^\\+1758\\d{7}$" },
    { code: "MF", name: "Saint Martin (French part)", phone: 590, regex: "^\\+590\\d{9}$" },
    { code: "PM", name: "Saint Pierre and Miquelon", phone: 508, regex: "^\\+508\\d{6}$" },
    { code: "VC", name: "Saint Vincent and the Grenadines", phone: 1784, regex: "^\\+1784\\d{7}$" },
    { code: "WS", name: "Samoa", phone: 685, regex: "^\\+685\\d{5,7}$" },
    { code: "SM", name: "San Marino", phone: 378, regex: "^\\+378\\d{10}$" },
    { code: "ST", name: "Sao Tome and Principe", phone: 239, regex: "^\\+239\\d{7}$" },
    { code: "SA", name: "Saudi Arabia", phone: 966, regex: "^\\+966\\d{8,9}$" },
    { code: "SN", name: "Senegal", phone: 221, regex: "^\\+221\\d{9}$" },
    { code: "RS", name: "Serbia", phone: 381, regex: "^\\+381\\d{8,9}$" },
    { code: "SC", name: "Seychelles", phone: 248, regex: "^\\+248\\d{7}$" },
    { code: "SL", name: "Sierra Leone", phone: 232, regex: "^\\+232\\d{8,9}$" },
    { code: "SG", name: "Singapore", phone: 65, regex: "^\\+65\\d{8}$" },
    { code: "SX", name: "Sint Maarten (Dutch part)", phone: 1, regex: "^\\+1\\d{10}$" },
    { code: "SK", name: "Slovakia", phone: 421, regex: "^\\+421\\d{9}$" },
    { code: "SI", name: "Slovenia", phone: 386, regex: "^\\+386\\d{8}$" },
    { code: "SB", name: "Solomon Islands", phone: 677, regex: "^\\+677\\d{5,7}$" },
    { code: "SO", name: "Somalia", phone: 252, regex: "^\\+252\\d{7,9}$" },
    { code: "ZA", name: "South Africa", phone: 27, regex: "^\\+27\\d{9}$" },
    { code: "GS", name: "South Georgia and the South Sandwich Islands", phone: 500, regex: "^\\+500\\d{5}$" },
    { code: "SS", name: "South Sudan", phone: 211, regex: "^\\+211\\d{9}$" },
    { code: "ES", name: "Spain", phone: 34, regex: "^\\+34\\d{9}$" },
    { code: "LK", name: "Sri Lanka", phone: 94, regex: "^\\+94\\d{8,9}$" },
    { code: "SD", name: "Sudan", phone: 249, regex: "^\\+249\\d{8,9}$" },
    { code: "SR", name: "Suriname", phone: 597, regex: "^\\+597\\d{7}$" },
    { code: "SJ", name: "Svalbard and Jan Mayen", phone: 47, regex: "^\\+47\\d{8}$" },
    { code: "SZ", name: "Swaziland", phone: 268, regex: "^\\+268\\d{8}$" },
    { code: "SE", name: "Sweden", phone: 46, regex: "^\\+46\\d{9}$" },
    { code: "CH", name: "Switzerland", phone: 41, regex: "^\\+41\\d{9}$" },
    { code: "SY", name: "Syrian Arab Republic", phone: 963, regex: "^\\+963\\d{8,9}$" },
    { code: "TW", name: "Taiwan, Province of China", phone: 886, regex: "^\\+886\\d{8,9}$" },
    { code: "TJ", name: "Tajikistan", phone: 992, regex: "^\\+992\\d{8,9}$" },
    { code: "TZ", name: "Tanzania, United Republic of", phone: 255, regex: "^\\+255\\d{9}$" },
    { code: "TH", name: "Thailand", phone: 66, regex: "^\\+66\\d{8,9}$" },
    { code: "TL", name: "Timor-Leste", phone: 670, regex: "^\\+670\\d{7}$" },
    { code: "TG", name: "Togo", phone: 228, regex: "^\\+228\\d{8}$" },
    { code: "TK", name: "Tokelau", phone: 690, regex: "^\\+690\\d{4}$" },
    { code: "TO", name: "Tonga", phone: 676, regex: "^\\+676\\d{5,7}$" },
    { code: "TT", name: "Trinidad and Tobago", phone: 1868, regex: "^\\+1868\\d{7}$" },
    { code: "TN", name: "Tunisia", phone: 216, regex: "^\\+216\\d{8}$" },
    { code: "TR", name: "Turkey", phone: 90, regex: "^\\+90\\d{10}$" },
    { code: "TM", name: "Turkmenistan", phone: 993, regex: "^\\+993\\d{8,9}$" },
    { code: "TC", name: "Turks and Caicos Islands", phone: 1649, regex: "^\\+1649\\d{7}$" },
    { code: "TV", name: "Tuvalu", phone: 688, regex: "^\\+688\\d{5}$" },
    { code: "UG", name: "Uganda", phone: 256, regex: "^\\+256\\d{9}$" },
    { code: "UA", name: "Ukraine", phone: 380, regex: "^\\+380\\d{9}$" },
    { code: "AE", name: "United Arab Emirates", phone: 971, regex: "^\\+971\\d{8,9}$" },
    { code: "GB", name: "United Kingdom", phone: 44, regex: "^\\+44\\d{10}$" },
    { code: "US", name: "United States", phone: 1, regex: "^\\+1\\d{10}$" },
    { code: "UY", name: "Uruguay", phone: 598, regex: "^\\+598\\d{8}$" },
    { code: "UZ", name: "Uzbekistan", phone: 998, regex: "^\\+998\\d{8,9}$" },
    { code: "VU", name: "Vanuatu", phone: 678, regex: "^\\+678\\d{5,7}$" },
    { code: "VE", name: "Venezuela, Bolivarian Republic of", phone: 58, regex: "^\\+58\\d{8,9}$" },
    { code: "VN", name: "Viet Nam", phone: 84, regex: "^\\+84\\d{9}$" },
    { code: "VG", name: "Virgin Islands, British", phone: 1284, regex: "^\\+1284\\d{7}$" },
    { code: "VI", name: "Virgin Islands, U.s.", phone: 1340, regex: "^\\+1340\\d{7}$" },
    { code: "WF", name: "Wallis and Futuna", phone: 681, regex: "^\\+681\\d{6}$" },
    { code: "EH", name: "Western Sahara", phone: 212, regex: "^\\+212\\d{9}$" },
    { code: "YE", name: "Yemen", phone: 967, regex: "^\\+967\\d{7,9}$" },
    { code: "ZM", name: "Zambia", phone: 260, regex: "^\\+260\\d{9}$" },
    { code: "ZW", name: "Zimbabwe", phone: 263, regex: "^\\+263\\d{9}$" }
]

